// The issue count for a video and a strip showing its result mix
// (met / missed / unclear / flagged), from latest_check.counts.
import React from 'react';
import { TONE, summaryIssues } from './qcFormat';
import { C } from './ui';

const PARTS = [
    { key: 'met', label: 'met', tone: 'good' },
    { key: 'missed', label: 'missed', tone: 'bad' },
    { key: 'unclear', label: 'unclear', tone: 'warn' },
    { key: 'outliers', label: 'flagged', tone: 'flag' },
];

const countOf = (counts, key) => (Number.isFinite(counts?.[key]) ? Math.max(0, counts[key]) : 0);

export const describeCounts = (counts) => PARTS.map((p) => `${countOf(counts, p.key)} ${p.label}`).join(', ');

export function MiniStrip({ counts, width = 104 }) {
    const parts = PARTS.map((p) => ({ ...p, n: countOf(counts, p.key) })).filter((p) => p.n > 0);
    if (!parts.length) return null;
    const label = describeCounts(counts);
    return (
        <div role="img" aria-label={label} title={label} style={{ display: 'flex', gap: 2, width, height: 6 }}>
            {parts.map((p) => <span key={p.key} style={{ flex: p.n, background: TONE[p.tone].color, borderRadius: 3 }} />)}
        </div>
    );
}

export function IssueSummary({ latest }) {
    const issues = summaryIssues(latest);
    if (issues == null) return <span style={{ color: C.muted }}>—</span>;
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 5 }}>
                <span style={{ fontSize: 18, fontWeight: 800, color: issues ? '#b45309' : '#166534', lineHeight: 1 }}>{issues}</span>
                <span style={{ fontSize: 12, color: C.muted }}>{issues === 1 ? 'issue' : 'issues'}</span>
            </div>
            {latest.counts && <MiniStrip counts={latest.counts} />}
        </div>
    );
}
